import React from "react";
import { Route, Switch } from "react-router-dom";
import Login from "../pages/Login";
import PrivateRoute from "./../layout/PrivateRoute";
import MapPage from "./../pages/Map";
import Pricing from "./../pages/Plans";
import PlansCheckout from "./../pages/Plans/PlansCheckout";
import UnauthorizedAuth from "./../pages/UnauthorizedAuth";
import { UpdateEmail } from "./../pages/ValidateEmail/UpdateEmail";
import VerifyEmailCode from "./../pages/ValidateEmail/VerifyEmailCode";
import Workspace from "./../pages/Workspace";
import { AcceptInvitation } from "./../pages/Workspace/AcceptInvitation";
import VerifyWallet from "./../pages/Workspace/VerifyWallet";
import FeaturesRoutes from "./features";

const Routes: React.FC = () => {
  return (
    <Switch>
      <PrivateRoute
        path="/workspace/invitation/:invitationCode"
        component={AcceptInvitation}
      />
      <PrivateRoute path="/workspace/wallets/verify" component={VerifyWallet} />
      <Route path="/workspace" component={Workspace} />
      <Route path="/pricing" component={Pricing} />
      <Route path="/checkout" component={PlansCheckout} />
      <Route
        path={["/hotspots", "/locations", "/contacts", "/installs", "/hexes"]}
        component={MapPage}
      />
      <Route exact path="/auth/discord/error" component={UnauthorizedAuth} />
      <Route exact path="/auth/email/update" component={UpdateEmail} />
      <Route exact path="/auth/email/verify-code" component={VerifyEmailCode} />
      <Route path="/login" component={Login} />

      <FeaturesRoutes />
    </Switch>
  );
};

export default Routes;
